// All 38 inline SVG logo components for QNNEAL platforms
// Each accepts className and variant ('color' | 'mono') props

import React from "react";

const sz = { sm: 24, md: 36, lg: 48, xl: 64 };
const wrap = (Svg) => ({ size = "md", className = "", variant = "color", ...props }) => (
  <Svg width={sz[size] || size} height={sz[size] || size} className={className} variant={variant} {...props} />
);

// ─── TIER 1: AI Platforms ───

export const OpenAILogo = wrap(({ width, height, className, variant }) => (
  <svg viewBox="0 0 24 24" width={width} height={height} className={className} fill="none">
    <path d="M22.282 9.821a5.985 5.985 0 0 0-.516-4.91 6.046 6.046 0 0 0-6.51-2.9A6.065 6.065 0 0 0 4.981 4.18a5.998 5.998 0 0 0-3.998 2.9 6.042 6.042 0 0 0 .743 7.097 5.98 5.98 0 0 0 .51 4.911 6.051 6.051 0 0 0 6.515 2.9A5.985 5.985 0 0 0 13.26 24a6.056 6.056 0 0 0 5.772-4.206 5.99 5.99 0 0 0 3.997-2.9 6.056 6.056 0 0 0-.747-7.073zM13.26 22.43a4.476 4.476 0 0 1-2.876-1.04l.141-.081 4.779-2.758a.795.795 0 0 0 .392-.681v-6.737l2.02 1.168a.071.071 0 0 1 .038.052v5.583a4.504 4.504 0 0 1-4.494 4.494zM3.6 18.304a4.47 4.47 0 0 1-.535-3.014l.142.085 4.783 2.759a.771.771 0 0 0 .78 0l5.843-3.369v2.332a.08.08 0 0 1-.033.062L9.74 19.95a4.5 4.5 0 0 1-6.14-1.646zM2.34 7.896a4.485 4.485 0 0 1 2.366-1.973V11.6a.766.766 0 0 0 .388.676l5.815 3.355-2.02 1.168a.076.076 0 0 1-.071 0l-4.83-2.786A4.504 4.504 0 0 1 2.34 7.872zm16.597 3.855l-5.833-3.387L15.119 7.2a.076.076 0 0 1 .071 0l4.83 2.791a4.494 4.494 0 0 1-.676 8.105v-5.678a.79.79 0 0 0-.407-.667zm2.01-3.023l-.141-.085-4.774-2.782a.776.776 0 0 0-.785 0L9.409 9.23V6.897a.066.066 0 0 1 .028-.061l4.83-2.787a4.5 4.5 0 0 1 6.68 4.66zm-12.64 4.135l-2.02-1.164a.08.08 0 0 1-.038-.057V6.075a4.5 4.5 0 0 1 7.375-3.453l-.142.08L8.704 5.46a.795.795 0 0 0-.393.681zm1.097-2.365l2.602-1.5 2.607 1.5v2.999l-2.597 1.5-2.607-1.5z"
      fill="currentColor" />
  </svg>
));

export const GeminiLogo = wrap(({ width, height, className }) => (
  <svg viewBox="0 0 24 24" width={width} height={height} className={className} fill="none">
    <path d="M12 0C12 6.627 6.627 12 0 12c6.627 0 12 5.373 12 12 0-6.627 5.373-12 12-12-6.627 0-12-5.373-12-12z" fill="url(#gem_g)" />
    <defs><linearGradient id="gem_g" x1="0" y1="0" x2="24" y2="24">
      <stop offset="0%" stopColor="#4285F4" /><stop offset="25%" stopColor="#9B72CB" />
      <stop offset="50%" stopColor="#D96570" /><stop offset="75%" stopColor="#F49C46" />
      <stop offset="100%" stopColor="#4285F4" />
    </linearGradient></defs>
  </svg>
));

export const ClaudeLogo = wrap(({ width, height, className, variant }) => (
  <svg viewBox="0 0 24 24" width={width} height={height} className={className} fill="none">
    <path d="M15.788 3.036a1.474 1.474 0 0 0-1.994.569l-5.22 9.253-2.82-4.466a1.473 1.473 0 0 0-2.532 1.513l4.177 6.614a1.474 1.474 0 0 0 2.53-.046l6.428-11.443a1.474 1.474 0 0 0-.569-1.994z"
      fill={variant === "mono" ? "currentColor" : "#D97757"} />
    <path d="M17.815 7.402a1.474 1.474 0 1 0-2.63 1.325l.93 1.846a1.474 1.474 0 1 0 2.63-1.325z"
      fill={variant === "mono" ? "currentColor" : "#D97757"} />
  </svg>
));

export const AnthropicLogo = wrap(({ width, height, className }) => (
  <svg viewBox="0 0 24 24" width={width} height={height} className={className} fill="none">
    <path d="M13.827 3h2.69L22 21h-2.69l-5.483-18zm-6.344 0L2 21h2.69l1.294-4.268h6.266L13.544 21h2.69L10.751 3H7.483zm.489 11.127L10.2 7.403l2.229 6.724H7.972z"
      fill="currentColor" />
  </svg>
));

export const CopilotLogo = wrap(({ width, height, className }) => (
  <svg viewBox="0 0 24 24" width={width} height={height} className={className} fill="none">
    <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z" fill="url(#cop_g)" />
    <path d="M8 15.5c0-1.38 1.79-2.5 4-2.5s4 1.12 4 2.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="9.5" cy="10.5" r="1.5" fill="white" />
    <circle cx="14.5" cy="10.5" r="1.5" fill="white" />
    <defs><linearGradient id="cop_g" x1="2" y1="2" x2="22" y2="22">
      <stop offset="0%" stopColor="#2BC4F3" /><stop offset="33%" stopColor="#37D580" />
      <stop offset="66%" stopColor="#F2B824" /><stop offset="100%" stopColor="#ED5E2B" />
    </linearGradient></defs>
  </svg>
));

export const PerplexityLogo = wrap(({ width, height, className, variant }) => (
  <svg viewBox="0 0 24 24" width={width} height={height} className={className} fill="none">
    <path d="M12 2v8.5m0 3v8.5M2 12h8.5m3 0H22M5.636 5.636l6.01 6.01m.708.708l6.01 6.01M18.364 5.636l-6.01 6.01m-.708.708l-6.01 6.01"
      stroke={variant === "mono" ? "currentColor" : "#20808D"} strokeWidth="2" strokeLinecap="round" />
    <circle cx="12" cy="12" r="2" fill={variant === "mono" ? "currentColor" : "#20808D"} />
  </svg>
));

export const GrokLogo = wrap(({ width, height, className }) => (
  <svg viewBox="0 0 24 24" width={width} height={height} className={className} fill="none">
    <path d="M4 4l7 8-7 8h4l5-5.714L17 20h4l-7-8 7-8h-4l-5 5.714L7 4H4z"
      fill="currentColor" />
  </svg>
));

export const MetaAILogo = wrap(({ width, height, className, variant }) => (
  <svg viewBox="0 0 24 24" width={width} height={height} className={className} fill="none">
    <path d="M6.915 4.03c-1.968 0-3.402 1.218-4.393 2.9C.615 8.63.06 10.713.06 12.726c0 1.238.258 2.31.88 3.117.638.826 1.588 1.227 2.67 1.227 1.493 0 2.689-.85 3.797-2.06l.282-.318c.518.86 1.093 1.43 1.747 1.802.67.382 1.403.576 2.204.576 1.968 0 3.402-1.218 4.393-2.9.907-1.537 1.462-3.456 1.462-5.292V8.774h-.003c-.014-1.167-.286-2.186-.862-2.96-.635-.854-1.583-1.264-2.673-1.264-1.493 0-2.69.85-3.798 2.06L12 6.87c-.43-.734-.958-1.3-1.588-1.68C9.77 4.838 9.069 4.624 8.313 4.624z"
      fill={variant === "mono" ? "currentColor" : "#0668E1"} />
  </svg>
));

export const MistralLogo = wrap(({ width, height, className, variant }) => (
  <svg viewBox="0 0 24 24" width={width} height={height} className={className} fill="none">
    {/* Pixel "M" shape */}
    <rect x="2" y="4" width="4" height="4" fill={variant === "mono" ? "currentColor" : "#F7D046"} />
    <rect x="2" y="8" width="4" height="4" fill={variant === "mono" ? "currentColor" : "#F2A73B"} />
    <rect x="2" y="12" width="4" height="4" fill={variant === "mono" ? "currentColor" : "#EF8033"} />
    <rect x="2" y="16" width="4" height="4" fill={variant === "mono" ? "currentColor" : "#EE792F"} />
    <rect x="6" y="8" width="4" height="4" fill={variant === "mono" ? "currentColor" : "#F7D046"} />
    <rect x="10" y="4" width="4" height="4" fill={variant === "mono" ? "currentColor" : "#000000"} />
    <rect x="10" y="12" width="4" height="4" fill={variant === "mono" ? "currentColor" : "#000000"} />
    <rect x="14" y="8" width="4" height="4" fill={variant === "mono" ? "currentColor" : "#F7D046"} />
    <rect x="18" y="4" width="4" height="4" fill={variant === "mono" ? "currentColor" : "#F7D046"} />
    <rect x="18" y="8" width="4" height="4" fill={variant === "mono" ? "currentColor" : "#F2A73B"} />
    <rect x="18" y="12" width="4" height="4" fill={variant === "mono" ? "currentColor" : "#EF8033"} />
    <rect x="18" y="16" width="4" height="4" fill={variant === "mono" ? "currentColor" : "#EE792F"} />
  </svg>
));

// ─── TIER 2: Developer Frameworks ───

export const CrewAILogo = wrap(({ width, height, className, variant }) => (
  <svg viewBox="0 0 24 24" width={width} height={height} className={className} fill="none">
    <circle cx="8" cy="8" r="3" stroke={variant === "mono" ? "currentColor" : "#10B981"} strokeWidth="1.5" />
    <circle cx="16" cy="8" r="3" stroke={variant === "mono" ? "currentColor" : "#10B981"} strokeWidth="1.5" />
    <circle cx="12" cy="16" r="3" stroke={variant === "mono" ? "currentColor" : "#10B981"} strokeWidth="1.5" />
    <line x1="10" y1="9.5" x2="13" y2="14" stroke={variant === "mono" ? "currentColor" : "#10B981"} strokeWidth="1.2" />
    <line x1="14" y1="9.5" x2="11" y2="14" stroke={variant === "mono" ? "currentColor" : "#10B981"} strokeWidth="1.2" />
    <line x1="9.5" y1="10" x2="14.5" y2="10" stroke={variant === "mono" ? "currentColor" : "#10B981"} strokeWidth="1.2" />
  </svg>
));

export const AutoGenLogo = wrap(({ width, height, className, variant }) => (
  <svg viewBox="0 0 24 24" width={width} height={height} className={className} fill="none">
    <rect x="3" y="3" width="18" height="18" rx="3" stroke={variant === "mono" ? "currentColor" : "#3B82F6"} strokeWidth="1.5" />
    <path d="M8 12h8M12 8v8M7 7l3 3M14 14l3 3" stroke={variant === "mono" ? "currentColor" : "#3B82F6"} strokeWidth="1.5" strokeLinecap="round" />
  </svg>
));

export const LangChainLogo = wrap(({ width, height, className, variant }) => (
  <svg viewBox="0 0 24 24" width={width} height={height} className={className} fill="none">
    <path d="M12 2L4 7v10l8 5 8-5V7l-8-5z" stroke={variant === "mono" ? "currentColor" : "#2D6B4D"} strokeWidth="1.5" fill="none" />
    <circle cx="12" cy="7" r="1.5" fill={variant === "mono" ? "currentColor" : "#2D6B4D"} />
    <circle cx="7" cy="14" r="1.5" fill={variant === "mono" ? "currentColor" : "#2D6B4D"} />
    <circle cx="17" cy="14" r="1.5" fill={variant === "mono" ? "currentColor" : "#2D6B4D"} />
    <line x1="12" y1="8.5" x2="8" y2="13" stroke={variant === "mono" ? "currentColor" : "#2D6B4D"} strokeWidth="1.2" />
    <line x1="12" y1="8.5" x2="16" y2="13" stroke={variant === "mono" ? "currentColor" : "#2D6B4D"} strokeWidth="1.2" />
  </svg>
));

export const LangGraphLogo = wrap(({ width, height, className, variant }) => (
  <svg viewBox="0 0 24 24" width={width} height={height} className={className} fill="none">
    <circle cx="6" cy="6" r="2.5" stroke={variant === "mono" ? "currentColor" : "#F59E0B"} strokeWidth="1.5" />
    <circle cx="18" cy="6" r="2.5" stroke={variant === "mono" ? "currentColor" : "#F59E0B"} strokeWidth="1.5" />
    <circle cx="12" cy="18" r="2.5" stroke={variant === "mono" ? "currentColor" : "#F59E0B"} strokeWidth="1.5" />
    <path d="M8 7.5l2.5 8.5M16 7.5l-2.5 8.5M8.5 6h7" stroke={variant === "mono" ? "currentColor" : "#F59E0B"} strokeWidth="1.2" strokeLinecap="round" />
  </svg>
));

export const ManusLogo = wrap(({ width, height, className, variant }) => (
  <svg viewBox="0 0 24 24" width={width} height={height} className={className} fill="none">
    <path d="M12 3L3 8v8l9 5 9-5V8l-9-5z" fill={variant === "mono" ? "currentColor" : "#8B5CF6"} opacity="0.15" />
    <path d="M12 3L3 8v8l9 5 9-5V8l-9-5z" stroke={variant === "mono" ? "currentColor" : "#8B5CF6"} strokeWidth="1.5" />
    <path d="M12 8v9M8 10.5l4 2.5 4-2.5" stroke={variant === "mono" ? "currentColor" : "#8B5CF6"} strokeWidth="1.5" strokeLinecap="round" />
  </svg>
));

export const EmergentLogo = wrap(({ width, height, className, variant }) => (
  <svg viewBox="0 0 24 24" width={width} height={height} className={className} fill="none">
    <path d="M4 12a8 8 0 0 1 8-8" stroke={variant === "mono" ? "currentColor" : "#06B6D4"} strokeWidth="2" strokeLinecap="round" />
    <path d="M12 4a8 8 0 0 1 8 8" stroke={variant === "mono" ? "currentColor" : "#8B5CF6"} strokeWidth="2" strokeLinecap="round" />
    <path d="M20 12a8 8 0 0 1-8 8" stroke={variant === "mono" ? "currentColor" : "#10B981"} strokeWidth="2" strokeLinecap="round" />
    <path d="M12 20a8 8 0 0 1-8-8" stroke={variant === "mono" ? "currentColor" : "#F59E0B"} strokeWidth="2" strokeLinecap="round" />
    <circle cx="12" cy="12" r="2.5" fill={variant === "mono" ? "currentColor" : "#06B6D4"} />
  </svg>
));

export const CursorLogo = wrap(({ width, height, className, variant }) => (
  <svg viewBox="0 0 24 24" width={width} height={height} className={className} fill="none">
    <rect x="3" y="3" width="18" height="18" rx="4" fill={variant === "mono" ? "currentColor" : "#555555"} />
    <path d="M8 16V8l8 4-8 4z" fill="white" />
  </svg>
));

export const WindsurfLogo = wrap(({ width, height, className, variant }) => (
  <svg viewBox="0 0 24 24" width={width} height={height} className={className} fill="none">
    <path d="M3 17c3-3 6-1 9-4s6-8 9-5" stroke={variant === "mono" ? "currentColor" : "#06B6D4"} strokeWidth="2" strokeLinecap="round" />
    <path d="M3 13c3-3 6-1 9-4s6-8 9-5" stroke={variant === "mono" ? "currentColor" : "#06B6D4"} strokeWidth="2" strokeLinecap="round" opacity="0.5" />
  </svg>
));

export const VSCodeLogo = wrap(({ width, height, className, variant }) => (
  <svg viewBox="0 0 24 24" width={width} height={height} className={className} fill="none">
    <path d="M17.583 2.894L12.66 7.212 7.95 3.87 3 6.066v11.868l4.95 2.196 4.71-3.342 4.923 4.318L22 18.874V5.126l-4.417-2.232zm-.034 3.217v11.778l-3.576-2.622-4.088 2.897-3.923-1.741V7.577l3.923-1.741 4.088 2.897 3.576-2.622z"
      fill={variant === "mono" ? "currentColor" : "#007ACC"} />
  </svg>
));

export const ReplitLogo = wrap(({ width, height, className, variant }) => (
  <svg viewBox="0 0 24 24" width={width} height={height} className={className} fill="none">
    <path d="M6 4h7a5 5 0 0 1 0 10H6V4z" fill={variant === "mono" ? "currentColor" : "#F26207"} />
    <path d="M6 14h7a5 5 0 0 1 0 10H6V14z" fill={variant === "mono" ? "currentColor" : "#F26207"} opacity="0.6" />
    <circle cx="17" cy="14" r="3" fill={variant === "mono" ? "currentColor" : "#0D47A1"} />
  </svg>
));

export const GoogleAILogo = wrap(({ width, height, className }) => (
  <svg viewBox="0 0 24 24" width={width} height={height} className={className} fill="none">
    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4" />
    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" />
    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05" />
    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" />
  </svg>
));

// ─── TIER 3: Global & Regional AI ───

export const DeepSeekLogo = wrap(({ width, height, className, variant }) => (
  <svg viewBox="0 0 24 24" width={width} height={height} className={className} fill="none">
    <path d="M12 3c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9z" fill={variant === "mono" ? "currentColor" : "#4D6BFE"} opacity="0.15" />
    <path d="M12 3c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9z" stroke={variant === "mono" ? "currentColor" : "#4D6BFE"} strokeWidth="1.5" />
    <path d="M7 14c1-2 3-3 5-3s4 1 5 3" stroke={variant === "mono" ? "currentColor" : "#4D6BFE"} strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="9" cy="10" r="1" fill={variant === "mono" ? "currentColor" : "#4D6BFE"} />
    <circle cx="15" cy="10" r="1" fill={variant === "mono" ? "currentColor" : "#4D6BFE"} />
  </svg>
));

export const BaiduLogo = wrap(({ width, height, className, variant }) => (
  <svg viewBox="0 0 24 24" width={width} height={height} className={className} fill="none">
    <path d="M9.5 4a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zM14.5 4a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zM6 10.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zM18 10.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zM12 13c-2.5 0-5 2-5 5s3 3 5 3 5 0 5-3-2.5-5-5-5z"
      fill={variant === "mono" ? "currentColor" : "#DE1B22"} />
  </svg>
));

export const QwenLogo = wrap(({ width, height, className, variant }) => (
  <svg viewBox="0 0 24 24" width={width} height={height} className={className} fill="none">
    <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z" stroke={variant === "mono" ? "currentColor" : "#FF6A00"} strokeWidth="1.5" />
    <path d="M8 12a4 4 0 0 1 8 0 4 4 0 0 1-8 0z" stroke={variant === "mono" ? "currentColor" : "#FF6A00"} strokeWidth="1.5" />
    <path d="M15 15l3.5 3.5" stroke={variant === "mono" ? "currentColor" : "#FF6A00"} strokeWidth="1.5" strokeLinecap="round" />
  </svg>
));

export const ZhipuLogo = wrap(({ width, height, className, variant }) => (
  <svg viewBox="0 0 24 24" width={width} height={height} className={className} fill="none">
    <rect x="3" y="3" width="18" height="18" rx="4" stroke={variant === "mono" ? "currentColor" : "#1A73E8"} strokeWidth="1.5" />
    <text x="12" y="16" textAnchor="middle" fontSize="10" fontWeight="bold" fill={variant === "mono" ? "currentColor" : "#1A73E8"} fontFamily="sans-serif">AI</text>
  </svg>
));

export const NaverLogo = wrap(({ width, height, className, variant }) => (
  <svg viewBox="0 0 24 24" width={width} height={height} className={className} fill="none">
    <path d="M14.55 12.82L9.14 4.65H4.65v14.7h4.8v-8.18l5.42 8.18h4.48V4.65h-4.8v8.17z"
      fill={variant === "mono" ? "currentColor" : "#03C75A"} />
  </svg>
));

export const KakaoLogo = wrap(({ width, height, className, variant }) => (
  <svg viewBox="0 0 24 24" width={width} height={height} className={className} fill="none">
    <path d="M12 3C7.029 3 3 6.134 3 10c0 2.527 1.697 4.742 4.227 6.003l-.857 3.18a.5.5 0 0 0 .76.536l3.574-2.382c.425.047.86.073 1.296.073 4.971 0 9-3.134 9-7 0-3.866-4.029-7-9-7z"
      fill={variant === "mono" ? "currentColor" : "#FEE500"} />
  </svg>
));

export const SakanaLogo = wrap(({ width, height, className, variant }) => (
  <svg viewBox="0 0 24 24" width={width} height={height} className={className} fill="none">
    <path d="M4 12c2-4 5-6 8-6s6 2 8 6c-2 4-5 6-8 6s-6-2-8-6z" stroke={variant === "mono" ? "currentColor" : "#FF6B6B"} strokeWidth="1.5" />
    <circle cx="14" cy="11" r="1.5" fill={variant === "mono" ? "currentColor" : "#FF6B6B"} />
    <path d="M20 10c1-2 1.5-4 1-6" stroke={variant === "mono" ? "currentColor" : "#FF6B6B"} strokeWidth="1.5" strokeLinecap="round" />
  </svg>
));

export const PFNLogo = wrap(({ width, height, className, variant }) => (
  <svg viewBox="0 0 24 24" width={width} height={height} className={className} fill="none">
    <polygon points="12,3 21,8 21,16 12,21 3,16 3,8" stroke={variant === "mono" ? "currentColor" : "#0058A4"} strokeWidth="1.5" fill="none" />
    <polygon points="12,7 17,9.5 17,14.5 12,17 7,14.5 7,9.5" fill={variant === "mono" ? "currentColor" : "#0058A4"} opacity="0.3" />
  </svg>
));

export const AlephAlphaLogo = wrap(({ width, height, className, variant }) => (
  <svg viewBox="0 0 24 24" width={width} height={height} className={className} fill="none">
    <text x="12" y="18" textAnchor="middle" fontSize="18" fontWeight="bold" fill={variant === "mono" ? "currentColor" : "#6B21A8"} fontFamily="serif">N</text>
  </svg>
));

export const AI21Logo = wrap(({ width, height, className, variant }) => (
  <svg viewBox="0 0 24 24" width={width} height={height} className={className} fill="none">
    <text x="12" y="17" textAnchor="middle" fontSize="12" fontWeight="bold" fill={variant === "mono" ? "currentColor" : "#5046E5"} fontFamily="sans-serif">AI21</text>
  </svg>
));

export const CohereLogo = wrap(({ width, height, className, variant }) => (
  <svg viewBox="0 0 24 24" width={width} height={height} className={className} fill="none">
    <circle cx="12" cy="12" r="9" stroke={variant === "mono" ? "currentColor" : "#D18EE2"} strokeWidth="1.5" />
    <path d="M8 12c0-2.2 1.8-4 4-4" stroke={variant === "mono" ? "currentColor" : "#39594D"} strokeWidth="2.5" strokeLinecap="round" />
    <circle cx="15" cy="14" r="2" fill={variant === "mono" ? "currentColor" : "#FF7759"} />
  </svg>
));

export const KrutrimLogo = wrap(({ width, height, className, variant }) => (
  <svg viewBox="0 0 24 24" width={width} height={height} className={className} fill="none">
    <path d="M12 2l9 5v10l-9 5-9-5V7l9-5z" stroke={variant === "mono" ? "currentColor" : "#FF5722"} strokeWidth="1.5" />
    <circle cx="12" cy="12" r="3" fill={variant === "mono" ? "currentColor" : "#FF5722"} opacity="0.4" />
  </svg>
));

export const SarvamLogo = wrap(({ width, height, className, variant }) => (
  <svg viewBox="0 0 24 24" width={width} height={height} className={className} fill="none">
    <path d="M4 12c0-4.418 3.582-8 8-8" stroke={variant === "mono" ? "currentColor" : "#E91E63"} strokeWidth="2" strokeLinecap="round" />
    <path d="M12 4c4.418 0 8 3.582 8 8" stroke={variant === "mono" ? "currentColor" : "#9C27B0"} strokeWidth="2" strokeLinecap="round" />
    <path d="M20 12c0 4.418-3.582 8-8 8" stroke={variant === "mono" ? "currentColor" : "#3F51B5"} strokeWidth="2" strokeLinecap="round" />
    <path d="M12 20c-4.418 0-8-3.582-8-8" stroke={variant === "mono" ? "currentColor" : "#00BCD4"} strokeWidth="2" strokeLinecap="round" />
  </svg>
));

export const FalconLogo = wrap(({ width, height, className, variant }) => (
  <svg viewBox="0 0 24 24" width={width} height={height} className={className} fill="none">
    <path d="M4 18L12 4l3 7h5l-8 9-1-5-7 3z" fill={variant === "mono" ? "currentColor" : "#B8860B"} />
  </svg>
));

export const JaisLogo = wrap(({ width, height, className, variant }) => (
  <svg viewBox="0 0 24 24" width={width} height={height} className={className} fill="none">
    <rect x="3" y="3" width="18" height="18" rx="4" stroke={variant === "mono" ? "currentColor" : "#1E3A5F"} strokeWidth="1.5" />
    <text x="12" y="16" textAnchor="middle" fontSize="9" fontWeight="bold" fill={variant === "mono" ? "currentColor" : "#1E3A5F"} fontFamily="sans-serif">G42</text>
  </svg>
));

export const YandexLogo = wrap(({ width, height, className, variant }) => (
  <svg viewBox="0 0 24 24" width={width} height={height} className={className} fill="none">
    <path d="M13 21V3h-2.5c-3 0-5.5 2.2-5.5 5.2 0 2.1 1.2 3.6 3.5 5L5 21h3l3-7.5V21h2z"
      fill={variant === "mono" ? "currentColor" : "#FF0000"} />
  </svg>
));

export const GigaChatLogo = wrap(({ width, height, className, variant }) => (
  <svg viewBox="0 0 24 24" width={width} height={height} className={className} fill="none">
    <circle cx="12" cy="12" r="9.5" stroke={variant === "mono" ? "currentColor" : "#21A038"} strokeWidth="1.5" />
    <path d="M8 11c0 0 1.5-2 4-2s4 2 4 2" stroke={variant === "mono" ? "currentColor" : "#21A038"} strokeWidth="1.5" strokeLinecap="round" />
    <path d="M8 14c0 0 1.5 2 4 2s4-2 4-2" stroke={variant === "mono" ? "currentColor" : "#21A038"} strokeWidth="1.5" strokeLinecap="round" />
  </svg>
));

export const LelapaLogo = wrap(({ width, height, className, variant }) => (
  <svg viewBox="0 0 24 24" width={width} height={height} className={className} fill="none">
    <circle cx="12" cy="12" r="9" stroke={variant === "mono" ? "currentColor" : "#E65100"} strokeWidth="1.5" />
    <path d="M8 9l4 6 4-6" stroke={variant === "mono" ? "currentColor" : "#E65100"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
));

export const SEAAILogo = wrap(({ width, height, className, variant }) => (
  <svg viewBox="0 0 24 24" width={width} height={height} className={className} fill="none">
    <path d="M3 12c3-6 6-9 9-9s6 3 9 9c-3 6-6 9-9 9s-6-3-9-9z" stroke={variant === "mono" ? "currentColor" : "#00838F"} strokeWidth="1.5" />
    <circle cx="12" cy="12" r="3" fill={variant === "mono" ? "currentColor" : "#00838F"} opacity="0.3" />
  </svg>
));

// ─── Logo Map ───

export const LOGO_MAP = {
  OpenAILogo, GeminiLogo, ClaudeLogo, AnthropicLogo, CopilotLogo, PerplexityLogo,
  GrokLogo, MetaAILogo, MistralLogo, CrewAILogo, AutoGenLogo, LangChainLogo,
  LangGraphLogo, ManusLogo, EmergentLogo, CursorLogo, WindsurfLogo, VSCodeLogo,
  ReplitLogo, GoogleAILogo, DeepSeekLogo, BaiduLogo, QwenLogo, ZhipuLogo,
  NaverLogo, KakaoLogo, SakanaLogo, PFNLogo, AlephAlphaLogo, AI21Logo,
  CohereLogo, KrutrimLogo, SarvamLogo, FalconLogo, JaisLogo, YandexLogo,
  GigaChatLogo, LelapaLogo, SEAAILogo,
};
